import { Container, Divider, Box } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  ModalError,
  Page,
  PrimaryButton,
  SearchTextInput,
  SkeletonComponent,
  StatusChip,
  TableAction,
  ButtonGroupTop
} from "components";
import { InnoTable } from "inno-ui";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { globalStyles } from "styles";
import { formatDate, getErrors } from "utils";
import { hardBaseUrl } from "../../../services/urlConstant";

function KontrakOriginalPublisher() {
  const classes = globalStyles();
  const location = useLocation();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const urlParams = new URLSearchParams(location.search);
  const paramsSearch = urlParams.get("search");
  const paramsPage = urlParams.get("page");
  const paramsSize = urlParams.get("limit");
  const paramsCategory = urlParams.get("offset");
  const paramsComposer = urlParams.get("composer");
  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    limit: Number(paramsSize) || 10,
    search: paramsSearch || "",
    offset: paramsCategory || "",
    composer: paramsComposer || "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/contract/original-publisher`,
        {
          headers,
          params: queryParams,
        }
      );

      const { data, meta } = res?.data;
      setDataTable(data?.contracts);
      const pageCount = getTotalPage(meta?.total, queryParams?.limit);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="Contract Original Publisher">
      <Container maxWidth={false}>
        <HeaderTitle
          title="Contract Original Publisher"
          breadcrumbData={breadcrumbData}
        />
        <ButtonGroupTop />
        <Box marginBottom="20px">
          <Divider />
        </Box>
        <Grid container justifyContent="space-between" mb="16px">
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              label="Create Contract"
              startIcon={<AddIcon />}
              onClick={() =>
                history.push("/admin/kontrak-original-publisher/tambah")
              }
            />
          </Grid>
        </Grid>
        {loadingPage ? (
          <SkeletonComponent variant="wave" />
        ) : (
          <InnoTable
            isLoading={false}
            columns={columnTable}
            items={dataTable}
            page={queryParams?.page}
            rowsPerPage={queryParams?.limit}
            totalPage={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangeRowsPerPage={e =>
              handleChangeQueryParams(e?.target?.value, "limit")
            }
            isHaveAction
            renderAction={item => (
              <TableAction
                handleView={() =>
                  history.push(
                    `/admin/kontrak-original-publisher/${item?.contract_id}`
                  )
                }
                handleEdit={() =>
                  history.push(
                    `/admin/kontrak-original-publisher/edit/${item?.contract_id}`
                  )
                }
              />
            )}
          />
        )}
      </Container>

    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Contract Original Publisher",
    active: true,
  },
];
const columnTable = [
  {
    name: "contract_number",
    title: "Contract Number",
    renderText: item => item || "-",
  },
  {
    name: "songs",
    title: "Song Title",
    componentType: "text",
    selectedKeyInside: "song_title",
  },
  {
    name: "original_publishers",
    title: "Original Publisher",
    renderText: item => <ArrayChip list={item} max={3} />,
  },
  {
    name: "start_date",
    title: "Start date",
    renderText: item => formatDate(moment(item, "DD-MM-YYYY HH:mm")),
  },
  {
    name: "end_date",
    title: "End Date",
    renderText: item => formatDate(moment(item, "DD-MM-YYYY HH:mm")),
  },
  {
    name: "is_active_flag",
    title: "Status",
    renderText: status => (
      <StatusChip
        type={status && "success"}
        label={status ? "Active" : "Inactive"}
      />
    ),
  },
];

export default KontrakOriginalPublisher;
